const envs: Record<string, string> =
  '__ENV__' in window
    ? (window as Window & { __ENV__: Record<string, string> }).__ENV__
    : {}
const isProd = envs.UVO_FIREBASE_CONFIG === 'production'

export const HOME_REGIONS = {
  africa: 'afr',
  arabworld: 'arb',
  india: 'ind',
  latinamerica: 'lam',
  ukraine: 'ukr',
  pakistan: 'pak',
  nepal: 'npl',
}

export const HOME_REGIONS_ALIAS = {
  afr: 'africa',
  arb: 'arabworld',
  ind: 'india',
  lam: 'latinamerica',
  ukr: 'ukraine',
  pak: 'pakistan',
  npl: 'nepal',
}

export const HOME_REGIONS_ALIAS_REGION_NAMES = {
  afr: 'Africa',
  arb: 'Arab World',
  ind: 'India',
  lam: 'Latin America',
  ukr: 'Ukraine',
  pak: 'Pakistan',
  npl: 'Nepal',
}

export const HOME_REGIONS_ALIAS_IDS = {
  afr: isProd ? 252 : 268,
  arb: isProd ? 255 : 292,
  ind: 101,
  lam: isProd ? 257 : 295,
  ukr: 230,
  pak: 167,
  npl: isProd ? 270 : 313,
}

export const HOME_REGIONS_IDS_ALIAS = Object.fromEntries(
  Object.entries(HOME_REGIONS_ALIAS_IDS).map(([alias, id]) => [id, alias])
) as Record<number, keyof typeof HOME_REGIONS_ALIAS_IDS>

export const GLOBAL_REGION = 'default'
